import api from './apiUtils';

const initialQuestionnaireName = 'SmartCat AI Readiness Assessment 2025';

//Get initial questinnaire id by activeQuestionnaire name provided in this file
const getInitialQuestionnaireId = async () => {
    return api.get(`/questionnaires`).then(response => {
        const questionnaire = response.data.find((q: {id: string, name: string}) => q.name === initialQuestionnaireName);
        return questionnaire ? questionnaire.id : null;
    })
    .catch((error) => {
        console.error('Failed to fetch questionnaires:', error);
        return null;
    });   
}

export default getInitialQuestionnaireId;